import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const Footer = () => {
  const [newsletterStatus, setNewsletterStatus] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_d6ainxm', 'template_1v9n8on', e.target, 'hoB1AWZoweGe6WGiO')
      .then(
        () => {
          setNewsletterStatus('success');
          e.target.reset();
        },
        () => {
          setNewsletterStatus('error');
        }
      );
  };

  return (
    <>
      {/* Main Footer */}
      <footer className="main-footer">
        <div className="auto-container">
          <div className="upper-box">
            <div className="logo">
              <a href="/">
                <img src="/assets/images/logo-2.png" alt="Vizox" />
              </a>
            </div>
            <div className="subscribe-form">
              <h5 className="title">Bültene Abone Ol</h5>
              <form onSubmit={handleSubscribe}>
                <div className="form-group">
                  <input
                    type="email"
                    name="user_email"
                    placeholder="Email Address"
                    required
                    className="email"
                  />
                  <button type="submit" className="theme-btn btn-style-one">
                    <span className="btn-title">Abone Ol</span>
                  </button>
                </div>
                {newsletterStatus === 'success' && (
                  <p style={{ color: 'white', marginTop: '10px' }}>Başarıyla abone olundu!</p>
                )}
                {newsletterStatus === 'error' && (
                  <p style={{ color: 'red', marginTop: '10px' }}>Bir hata oluştu. Lütfen tekrar deneyin.</p>
                )}
              </form>
            </div>
          </div>
        </div>

        {/* Widgets Section */}
        <div className="widgets-section">
          <div className="auto-container">
            <div className="row">
              {/* Footer Column - Contact */}
              <div className="footer-column col-xl-3 col-lg-4">
                <div className="footer-widget about-widget">
                  <h5 className="widget-title">İletişim</h5>
                  <div className="text">
                    66 Road Broklyn Street, 600 <br />
                    New York, USA
                  </div>
                  <ul className="contact-info">
                    <li><i className="fa fa-envelope"></i> <a href="mailto:info@vizox.com">info@vizox.com</a></li>
                    <li><i className="fa fa-phone-square"></i> <a href="tel:+926668880000">+92 666 888 0000</a></li>
                  </ul>
                </div>
              </div>

              {/* Footer Column - Links */}
              <div className="footer-column col-xl-6 col-lg-8 col-md-12 mb-0">
                <div className="footer-widget links-widget">
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <h5 className="widget-title">Keşfet</h5>
                      <ul className="user-links">
                        <li><a href="#">About Company</a></li>
                        <li><a href="#">Meet the Team</a></li>
                        <li><a href="#">News & Media</a></li>
                        <li><a href="#">Our Projects</a></li>
                        <li><a href="#">İletişim</a></li>
                      </ul>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <h5 className="widget-title">Vize</h5>
                      <ul className="user-links">
                        <li><a href="#">Öğrenci Vizesi</a></li>
                        <li><a href="#">İş Vizesi</a></li>
                        <li><a href="#">Aile Vizesi</a></li>
                        <li><a href="#">Seyahat Vizesi</a></li>
                        <li><a href="#">Çalışma Vizesi</a></li>
                      </ul>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <h5 className="widget-title">Hizmetler</h5>
                      <ul className="user-links">
                        <li><a href="#">PR Applicants</a></li>
                        <li><a href="#">Vize Danışmanlığı</a></li>
                        <li><a href="#">Seyahat Sigortası</a></li>
                        <li><a href="#">Çalışma İzinleri</a></li>
                        <li><a href="#">Yurtdışı Eğitim</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Footer Column - Gallery */}
              <div className="footer-column col-xl-3 col-lg-4 col-md-6">
                <div className="footer-widget gallery-widget">
                  <h5 className="widget-title">Galeri</h5>
                  <div className="widget-content">
                    <div className="outer clearfix">
                      {[1, 2, 3, 4, 5, 6].map((i) => (
                        <figure className="image" key={i}>
                          <a href="#">
                            <img src={`/assets/images/resource/project-thumb-${i}.jpg`} alt={`thumb-${i}`} />
                          </a>
                        </figure>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="auto-container">
            <div className="inner-container">
              <div className="copyright-text">
                © Copyright Reserved by <a href="/">kodesolution.com</a>
              </div>
              <ul className="social-icon-two">
                <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                <li><a href="#"><i className="fab fa-facebook"></i></a></li>
                <li><a href="#"><i className="fab fa-pinterest"></i></a></li>
                <li><a href="#"><i className="fab fa-instagram"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      {/* Scroll to Top */}
      <div className="scroll-to-top scroll-to-target" data-target="html">
        <span className="fa fa-angle-up"></span>
      </div>
    </>
  );
};

export default Footer;